import React from 'react';

import { CircularProgress } from '../../../utils/materialUI';
import { Col } from '../../../utils/bootstrapUtils';

const SingleColumnLayoutLoader = () => (
    <div>
        <div className="container-fluid full-page-container">
            <Col md={12}>
                <div
                    style={{ textAlign: 'center' }}
                >
                    <CircularProgress />
                </div>
            </Col>
        </div>
    </div>
);

export default SingleColumnLayoutLoader;
